var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout-item md-size-100" }, [
    _vm.adjustmentDetails.isDriver
      ? _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [
            _c(
              "form-group",
              {
                attrs: {
                  name: "teamMemberUserIds",
                  label: "Team member",
                  attribute: "Team member",
                },
              },
              [
                _c("md-input", {
                  attrs: { type: "hidden" },
                  model: {
                    value: _vm.adjustmentDetails.teamMemberUserIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "teamMemberUserIds", $$v)
                    },
                    expression: "adjustmentDetails.teamMemberUserIds",
                  },
                }),
                _c("vue-select", {
                  attrs: {
                    label: "fullName",
                    options: _vm.teamMembers,
                    reduce: function (r) {
                      return r.userId
                    },
                    multiple: true,
                    disabled: _vm.adjustmentDetails.isEditing,
                    "append-to-body": true,
                    "close-on-select": false,
                  },
                  model: {
                    value: _vm.adjustmentDetails.teamMemberUserIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "teamMemberUserIds", $$v)
                    },
                    expression: "adjustmentDetails.teamMemberUserIds",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.adjustmentDetails.isCustomer
      ? _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [
            _c(
              "form-group",
              {
                attrs: {
                  name: "customerIds",
                  label: "Customer",
                  attribute: "Customer",
                },
              },
              [
                _c("md-input", {
                  attrs: { type: "hidden" },
                  model: {
                    value: _vm.adjustmentDetails.customerIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "customerIds", $$v)
                    },
                    expression: "adjustmentDetails.customerIds",
                  },
                }),
                _c("vue-select", {
                  attrs: {
                    label: "value",
                    options: _vm.customers,
                    reduce: function (r) {
                      return Number(r.key)
                    },
                    multiple: true,
                    disabled: _vm.adjustmentDetails.isEditing,
                    "append-to-body": true,
                    "close-on-select": false,
                  },
                  model: {
                    value: _vm.adjustmentDetails.customerIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "customerIds", $$v)
                    },
                    expression: "adjustmentDetails.customerIds",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }